import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { config } from '../../shared/config';
import { map } from 'rxjs/operators';
import { BaseHttpService } from '../../core/services/base-http.service';
import { StorageService } from '../../core/storage/storage.service';
import { CreateZoneGroupModel, ZoneGroup } from '../models/zone-group';

@Injectable({
  providedIn: 'root'
})
export class ZoneGroupsService extends BaseHttpService {

  constructor(
    protected _http: HttpClient,
    protected _storage: StorageService,
  ) {
    super(_http, _storage);
  }

  getZoneGroups(): Observable<ZoneGroup[]> {
    return this.get(config.generateApiUrl(`zones/subscriptions/groups`, null, null, '2.2')).pipe(
      map((stat) => stat['data']['items'] as ZoneGroup[]));
  }

  createZoneGroup(data: CreateZoneGroupModel): Observable<ZoneGroup> {
    return this._http.post(config.generateApiUrl(`zones/subscriptions/groups`, null, null, '2.2'), data).pipe(
      map((stat) => stat['data']['item'] as ZoneGroup));
  }

  editZoneGroup(zoneGroupId: number, data: ZoneGroup): Observable<ZoneGroup> {
    return this._http.patch(config.generateApiUrl(`zones/subscriptions/groups/zoneGroup/${zoneGroupId}`, null, null, '2.2'), data).pipe(
      map((stat) => stat['data']['item'] as ZoneGroup));
  }

  assignZoneToGroup(zoneGroupId: number, zoneId: number): Observable<ZoneGroup> {
    return this._http.put(config.generateApiUrl(`zones/subscriptions/groups/${zoneGroupId}/zone/${zoneId}`, null, null, '2.2'), null).pipe(
      map((stat) => stat['data']['item'] as ZoneGroup)
    );
  }

  unassignZoneToGroup(zoneGroupId: number, zoneId: number): Observable<any> {
    return this._http.delete(config.generateApiUrl(`zones/subscriptions/groups/${zoneGroupId}/zone/${zoneId}`, null, null, '2.2'));
  }

  deleteZoneGroup(zoneGroupId: number): Observable<any> {
    return this._http.delete(config.generateApiUrl(`zones/subscriptions/groups/${zoneGroupId}`, null, null, '2.2'));
  }

}
